"use client";

import { useAppSelector } from "@/redux/hooks";
import { isPartnerReferredUser } from "@/services/auth-service";

export type PartnerBranding = {
  isBrandingReady: boolean;
  isReferredByPartner: boolean;
  partner: OrganizationPartner | null;
  partnerLogoUrl: string | null;
  partnerName: string | null;
  showPoweredBy: boolean;
};

export function usePartnerBranding(): PartnerBranding {
  const user = useAppSelector((state) => state.user.user);
  const isReferredByPartner = isPartnerReferredUser(user);
  const partner = isReferredByPartner ? user?.organization?.partner ?? null : null;

  return {
    // Ready as soon as a user exists, and it stays ready across a refetch:
    // the user already in the store still carries the partner, so the logo
    // never falls back to the default part-way through an update.
    isBrandingReady: Boolean(user),
    isReferredByPartner,
    partner,
    partnerLogoUrl: partner?.company_logo_url ?? null,
    partnerName: partner?.company_name?.trim() || null,
    showPoweredBy: Boolean(partner?.branding_enabled),
  };
}
